import {Device} from '../../constants';
import styled from 'styled-components';

export default styled.div`
  width: 50%;
  @media screen and ${Device.tablet} {
    width: 75%;
  }
  @media screen and ${Device.mobileL} {
    width: 100%;
  }
  input {
    display: block;
    margin: 1em auto 2em;
    padding: 1em;
    width: 100%;
    border: 1px solid $siteBlockBorder;
    background-color: transparent;
    font-weight: 700;
    font-size: 1em;
    text-align: center;
    text-transform: uppercase;
    @media screen and ${Device.mobileL} {
      font-size: 16px;
      line-height: 16px;
    }
    p.centered {
      @media screen and ${Device.mobileL} {
        text-align: left;
      }
    }
  }
  .errorMessage {
    display: block;
    margin-bottom: 2em;
    text-align: center;
    clear: both;
  }
`;
